import React, { type ComponentProps } from 'react';
import { StyleSheet, View } from 'react-native';
import { theme } from '@garnish/constants';

import { useResponsive } from '../../../../hooks';
import { Icon } from '../../../Icon';
import { BodyText } from '../../../Text';
import {
  ICON_SIZE_SM,
  ICON_SIZE_XS,
  QUANTITY_STEPPER_SIZE_SM,
  QUANTITY_STEPPER_SIZE_XS,
} from '../IngredientCardQuantityStepper/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const IngredientCardQuantity = (props: IngredientCardQuantityProps) => {
  const { children, iconName = 'IconCheck', shouldUseIcon } = props;

  const { match } = useResponsive();

  return (
    <View style={styles.container} pointerEvents="none">
      <View
        style={match([
          [styles.quantityContainer, styles.quantityContainerXS],
          [styles.quantityContainer, styles.quantityContainerSM],
        ])}
      >
        {shouldUseIcon ? (
          <Icon
            name={iconName}
            width={match([ICON_SIZE_XS, ICON_SIZE_SM])}
            height={match([ICON_SIZE_XS, ICON_SIZE_SM])}
            color={theme.colors.DARK_KALE}
          />
        ) : (
          <BodyText sizeMatch={['22']} maxFontSizeMultiplier={1.2}>
            {children}
          </BodyText>
        )}
      </View>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFillObject,
    alignItems: 'center',
    justifyContent: 'center',
  },
  quantityContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.colors.LIME,
    borderColor: theme.colors.DARK_KALE,
    borderWidth: 1,
  },
  quantityContainerXS: {
    width: QUANTITY_STEPPER_SIZE_XS,
    height: QUANTITY_STEPPER_SIZE_XS,
    borderRadius: QUANTITY_STEPPER_SIZE_XS,
  },
  quantityContainerSM: {
    width: QUANTITY_STEPPER_SIZE_SM,
    height: QUANTITY_STEPPER_SIZE_SM,
    borderRadius: QUANTITY_STEPPER_SIZE_SM,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type IngredientCardQuantityProps = {
  children?: string | number;
  iconName?: ComponentProps<typeof Icon>['name'];
  shouldUseIcon?: boolean;
};
